export default "__VITE_ASSET__DlnZLYal__";